// extracted by mini-css-extract-plugin
export default {"modal":"X3OTTa","grid":"Xvd1n1","skipTreatsButton":"tERovV","removeFromPlanButton":"jmgntU"};